// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from 'react';

const APPS = [
  { name: 'CropPatrol', brand: 'CropPatrol', icon: '\u{1F33E}', url: 'https://croppatrol.pages.dev', vertical: 'Agriculture', desc: 'Smart farm operations, crew, equipment & field management' },
  { name: 'Forge Fleet', brand: 'Forge Fleet', icon: '\u{1F69B}', url: 'https://haulsync.pages.dev', vertical: 'Trucking', desc: 'Fleet management, dispatch, driver logs & load tracking' },
  { name: 'Directional Ops', brand: 'Directional Ops', icon: '\u{1F6E2}', url: 'https://directional-ops.pages.dev', vertical: 'Oil & Gas', desc: 'Directional drilling operations & rig management' },
  { name: 'LotSync', brand: 'LotSync', icon: '\u{1F697}', url: 'https://lotsync.pages.dev', vertical: 'Auto Dealership', desc: 'Vehicle inventory, sales pipeline & lot management' },
  { name: 'NurseVault', brand: 'NurseVault', icon: '\u{1F3E5}', url: 'https://nursevault.pages.dev', vertical: 'Healthcare (US)', desc: 'Nursing shift management, patient tracking & compliance' },
  { name: 'NurseVault CA', brand: 'NurseVault CA', icon: '\u{1F1E8}\u{1F1E6}', url: 'https://nursevault-ca.pages.dev', vertical: 'Healthcare (CA)', desc: 'Canadian healthcare operations & provincial compliance' },
  { name: 'Vantage Ops', brand: 'Vantage Ops', icon: '\u{1F527}', url: 'https://vantage-ops.pages.dev', vertical: 'Field Service', desc: '6-vertical field service platform with dispatch & invoicing' },
  { name: 'BudLedger', brand: 'BudLedger', icon: '\u{1F33F}', url: 'https://budledger.pages.dev', vertical: 'Cannabis', desc: 'Seed-to-sale tracking, compliance & dispensary POS' },
  { name: 'OreSync', brand: 'OreSync', icon: '\u26CF', url: 'https://oresync.pages.dev', vertical: 'Mining', desc: 'Mining operations, safety compliance & equipment tracking' },
  { name: 'VacTraq', brand: 'VacTraq', icon: '\u{1F69C}', url: 'https://vactraq.pages.dev', vertical: 'Vac Hauling', desc: 'Vacuum truck dispatch, ticket management & billing' },
  { name: 'GlowDesk', brand: 'GlowDesk', icon: '\u{1F484}', url: 'https://glowdesk.pages.dev', vertical: 'Beauty & Salon', desc: 'Salon bookings, client management & stylist scheduling' },
  { name: 'ClosingDesk', brand: 'ClosingDesk', icon: '\u{1F3E0}', url: 'https://closingdesk.pages.dev', vertical: 'Real Estate', desc: 'Property listings, buyer CRM & closing pipeline' },
  { name: 'WrenchSync', brand: 'WrenchSync', icon: '\u{1F529}', url: 'https://wrenchsync.pages.dev', vertical: 'Auto Repair', desc: 'Work orders, parts inventory & customer estimates' },
  { name: 'TreadOps', brand: 'TreadOps', icon: '\u{1F6DE}', url: 'https://treadops.pages.dev', vertical: 'Tire Shop', desc: 'Tire inventory, installation scheduling & fleet accounts' },
  { name: 'HerdLedger', brand: 'HerdLedger', icon: '\u{1F404}', url: 'https://herdledger.pages.dev', vertical: 'Cattle/Ranch', desc: 'Herd management, breeding records & pasture tracking' },
  { name: 'VitaSync', brand: 'VitaSync', icon: '\u{1F9D8}', url: 'https://vitasync.pages.dev', vertical: 'Wellness', desc: 'Wellness practice management, client sessions & billing' },
  { name: 'PolicyForge', brand: 'PolicyForge', icon: '\u{1F6E1}', url: 'https://policyforge.pages.dev', vertical: 'Insurance', desc: 'Policy management, client renewals & commission tracking' },
  { name: 'MT Forge', brand: 'MT Forge', icon: '\u{1F3E2}', url: 'https://mt-forge-internal.pages.dev', vertical: 'Internal', desc: 'Mt Forge team hub & project management' },
  { name: 'StageVault', brand: 'StageVault', icon: '\u{1F3EA}', url: 'https://stagevault.pages.dev', vertical: 'Events', desc: 'Event venue booking, vendor coordination & floor plans' },
  { name: 'FormGenius', brand: 'FormGenius', icon: '\u{1F4C4}', url: 'https://formgenius.pages.dev', vertical: 'Forms & Docs', desc: 'Smart form builder, templates, digital signatures & compliance' },
  { name: 'IOD', brand: 'IOD', icon: '\u{1F6AA}', url: 'https://islandoverheaddoors.pages.dev', vertical: 'Overhead Doors', desc: 'Island Overhead Doors — job tracking & service management' },
  { name: 'IronLedger', brand: 'IronLedger', icon: '\u2692', url: 'https://ironledger.pages.dev', vertical: 'Iron & Steel', desc: 'Material tracking, fabrication orders & delivery scheduling' },
  { name: 'CropPatrol (Broda)', brand: 'CropPatrol', icon: '\u{1F331}', url: 'https://croppatrol-broda.pages.dev', vertical: 'Agriculture (WL)', desc: 'Broda Farms custom agriculture operations platform' },
  { name: 'LiftForge', brand: 'LiftForge', icon: '\u{1F3D7}', url: 'https://hoist-control.pages.dev', vertical: 'Hoist & Crane', desc: 'Crane operations, load calculations & safety inspections' },
  { name: 'RigForge', brand: 'RigForge', icon: '\u{1F6E2}', url: 'https://rigwarden.pages.dev', vertical: 'Rig Safety', desc: 'Rig safety compliance, BOP testing & incident reporting' },
  { name: 'TowForge', brand: 'TowForge', icon: '\u{1F69C}', url: 'https://towforge.pages.dev', vertical: 'Towing', desc: 'Tow dispatch, vehicle tracking & impound management' },
  { name: 'FRCC', brand: 'FRCC', icon: '\u{1F3CC}', url: 'https://filthy-redneck-cc.pages.dev', vertical: 'Country Club', desc: 'Membership management, event scheduling & facility booking' },
  { name: 'Forge Companion', brand: 'Forge Companion', icon: '\u{1F43E}', url: 'https://forge-companion.pages.dev', vertical: 'AI Pet Care', desc: '11-module AI pet care — health, nutrition, activity & vet records' },
  { name: 'FlorigenNFT', brand: 'FlorigenNFT', icon: '\u{1F338}', url: 'https://florigen-nft.pages.dev', vertical: 'Blockchain', desc: 'NFT minting, digital art marketplace & blockchain verification' },
  { name: 'AisleSync', brand: 'AisleSync', icon: '\u{1F6D2}', url: 'https://aislesync.pages.dev', vertical: 'Grocery', desc: 'Grocery & janitorial supply management' },
  { name: 'PlateSync', brand: 'PlateSync', icon: '\u{1F37D}', url: 'https://platesync.pages.dev', vertical: 'Restaurant', desc: 'Restaurant operations, menu management & order tracking' },
];

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#0f172a',
    color: '#f1f5f9',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    padding: '0',
    margin: '0',
  },
  container: {
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '40px 24px 60px',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
  },
  title: {
    fontSize: '36px',
    fontWeight: '700',
    margin: '0 0 8px 0',
    letterSpacing: '-0.5px',
    background: 'linear-gradient(135deg, #f1f5f9, #94a3b8)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  subtitle: {
    fontSize: '16px',
    color: '#94a3b8',
    margin: '0',
    fontWeight: '400',
  },
  statsBar: {
    display: 'flex',
    justifyContent: 'center',
    gap: '32px',
    marginBottom: '32px',
    flexWrap: 'wrap',
  },
  statItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 24px',
    backgroundColor: '#1e293b',
    borderRadius: '12px',
    border: '1px solid #334155',
  },
  statNumber: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#4F46E5',
  },
  statLabel: {
    fontSize: '13px',
    color: '#94a3b8',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  statusDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: '#22c55e',
    display: 'inline-block',
    marginRight: '6px',
    animation: 'none',
    boxShadow: '0 0 6px rgba(34,197,94,0.5)',
  },
  searchWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '36px',
  },
  searchInput: {
    width: '100%',
    maxWidth: '480px',
    padding: '14px 20px',
    fontSize: '15px',
    backgroundColor: '#1e293b',
    border: '1px solid #334155',
    borderRadius: '12px',
    color: '#f1f5f9',
    outline: 'none',
    transition: 'border-color 0.2s ease',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '20px',
  },
  card: {
    backgroundColor: '#1e293b',
    borderRadius: '16px',
    border: '1px solid #334155',
    padding: '28px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    transition: 'border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease',
    cursor: 'default',
    position: 'relative',
    overflow: 'hidden',
  },
  cardHover: {
    borderColor: '#4F46E5',
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 30px rgba(79,70,229,0.15)',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '12px',
  },
  iconContainer: {
    width: '48px',
    height: '48px',
    borderRadius: '12px',
    backgroundColor: 'rgba(79,70,229,0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    flexShrink: '0',
  },
  verticalBadge: {
    fontSize: '11px',
    fontWeight: '600',
    color: '#a5b4fc',
    backgroundColor: 'rgba(79,70,229,0.15)',
    padding: '4px 10px',
    borderRadius: '20px',
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',
    letterSpacing: '0.3px',
  },
  brandName: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#f1f5f9',
    margin: '0',
    lineHeight: '1.3',
  },
  appName: {
    fontSize: '13px',
    color: '#64748b',
    margin: '0',
    fontWeight: '500',
  },
  description: {
    fontSize: '14px',
    color: '#94a3b8',
    lineHeight: '1.5',
    margin: '0',
    flex: '1',
  },
  cardFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '4px',
  },
  statusBadge: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    color: '#22c55e',
    fontWeight: '600',
  },
  openButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 18px',
    backgroundColor: '#4F46E5',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    textDecoration: 'none',
  },
  openButtonHover: {
    backgroundColor: '#4338ca',
  },
  footer: {
    textAlign: 'center',
    marginTop: '60px',
    paddingTop: '32px',
    borderTop: '1px solid #1e293b',
  },
  footerText: {
    fontSize: '13px',
    color: '#475569',
    margin: '0 0 4px 0',
  },
  noResults: {
    gridColumn: '1 / -1',
    textAlign: 'center',
    padding: '60px 20px',
    color: '#64748b',
  },
  noResultsIcon: {
    fontSize: '48px',
    marginBottom: '16px',
    display: 'block',
  },
  noResultsText: {
    fontSize: '16px',
    margin: '0',
  },
};

const mediaQueryStyles = `
  @media (max-width: 1024px) {
    .apphub-grid {
      grid-template-columns: repeat(2, 1fr) !important;
    }
  }
  @media (max-width: 640px) {
    .apphub-grid {
      grid-template-columns: 1fr !important;
    }
    .apphub-title {
      font-size: 28px !important;
    }
    .apphub-container {
      padding: 24px 16px 40px !important;
    }
    .apphub-stats {
      gap: 12px !important;
    }
    .apphub-stat-item {
      padding: 10px 16px !important;
    }
  }
`;

function AppHubPage() {
  const [search, setSearch] = useState('');
  const [hoveredCard, setHoveredCard] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [searchFocused, setSearchFocused] = useState(false);

  const filteredApps = APPS.filter((app) => {
    const q = search.toLowerCase();
    return (
      app.name.toLowerCase().includes(q) ||
      app.brand.toLowerCase().includes(q) ||
      app.vertical.toLowerCase().includes(q) ||
      app.desc.toLowerCase().includes(q)
    );
  });

  const uniqueVerticals = [...new Set(APPS.map((a) => a.vertical))];

  return (
    <div style={styles.page}>
      <style>{mediaQueryStyles}</style>
      <div className="apphub-container" style={styles.container}>
        {/* Header */}
        <div style={styles.header}>
          <h1 className="apphub-title" style={styles.title}>App Hub</h1>
          <p style={styles.subtitle}>
            {APPS.length} Web Applications &mdash; Mt Forge
          </p>
        </div>

        {/* Stats Bar */}
        <div className="apphub-stats" style={styles.statsBar}>
          <div className="apphub-stat-item" style={styles.statItem}>
            <span style={styles.statNumber}>{APPS.length}</span>
            <span style={styles.statLabel}>Total Apps</span>
          </div>
          <div className="apphub-stat-item" style={styles.statItem}>
            <span style={styles.statNumber}>{uniqueVerticals.length}</span>
            <span style={styles.statLabel}>Industries</span>
          </div>
          <div className="apphub-stat-item" style={styles.statItem}>
            <span style={styles.statusDot} />
            <span style={{ ...styles.statLabel, color: '#22c55e' }}>All Live</span>
          </div>
        </div>

        {/* Search */}
        <div style={styles.searchWrapper}>
          <input
            type="text"
            placeholder="Search apps by name, brand, or industry..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              ...styles.searchInput,
              borderColor: searchFocused ? '#4F46E5' : '#334155',
            }}
            onFocus={() => setSearchFocused(true)}
            onBlur={() => setSearchFocused(false)}
          />
        </div>

        {/* Grid */}
        <div className="apphub-grid" style={styles.grid}>
          {filteredApps.length === 0 && (
            <div style={styles.noResults}>
              <span style={styles.noResultsIcon}>&#128269;</span>
              <p style={styles.noResultsText}>
                No apps match &ldquo;{search}&rdquo;
              </p>
            </div>
          )}
          {filteredApps.map((app, idx) => (
            <div
              key={app.name}
              style={{
                ...styles.card,
                ...(hoveredCard === idx ? styles.cardHover : {}),
              }}
              onMouseEnter={() => setHoveredCard(idx)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div style={styles.cardHeader}>
                <div style={styles.iconContainer}>
                  {app.icon}
                </div>
                <span style={styles.verticalBadge}>{app.vertical}</span>
              </div>

              <div>
                <h3 style={styles.brandName}>{app.brand}</h3>
                <p style={styles.appName}>{app.name}</p>
              </div>

              <p style={styles.description}>{app.desc}</p>

              <div style={styles.cardFooter}>
                <span style={styles.statusBadge}>
                  <span style={styles.statusDot} />
                  Live
                </span>
                <a
                  href={app.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    ...styles.openButton,
                    ...(hoveredButton === idx ? styles.openButtonHover : {}),
                  }}
                  onMouseEnter={() => setHoveredButton(idx)}
                  onMouseLeave={() => setHoveredButton(null)}
                >
                  Open App &#8599;
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <p style={styles.footerText}>
            Mt Forge &mdash; 121 Rainbow Falls Bay, Alberta
          </p>
          <p style={{ ...styles.footerText, color: '#334155' }}>
            r.miskulin@mtforge.ai
          </p>
        </div>
      </div>
    </div>
  );
}

export default AppHubPage;
